import React from 'react'
import { VIDEO_URL } from '../../../const/endpoints.ts'

export default function YoutubeResponsive() {
  return (
    <div className="video-frame">
      <iframe src={VIDEO_URL} title="Neurorule software tutorial" loading="lazy" referrerPolicy="strict-origin-when-cross-origin" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen />
    </div>
  )
}
